import { render, staticRenderFns } from "./respond-message.vue?vue&type=template&id=8af9ad88&scoped=true&"
import script from "./respond-message.vue?vue&type=script&lang=js&"
export * from "./respond-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af9ad88",
  null
  
)

export default component.exports